export default __webpack_public_path__ + "35c02c27966108fdac7fa8084e2990fbae6fe907a4d5ad5d013e13454d977173.png";